import { ChangeEvent, DetailedHTMLProps, HTMLAttributes } from 'react';
import authPass from 'components/Shared/FormField/auth-pass.svg';
import authFail from 'components/Shared/FormField/auth-fail.svg';
import styles from './styles';

interface FormFieldProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  label: string;
  error: string;
  showValidationIcon: boolean;
  disabled?: boolean;
  className?: string;
  onValidation?: (validationError: string) => void;
  value?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

function validationIcon(showValidationIcon: boolean, error: string): string {
  if (showValidationIcon && error) {
    return authFail;
  }
  if (showValidationIcon && !error) {
    return authPass;
  }
  return '';
}

export default function EmailSubmissionField({
  label,
  value,
  onChange,
  error,
  showValidationIcon,
  onValidation = (): void => {},
  onBlur,
  ...otherProps
}: FormFieldProps): JSX.Element {
  return (
    <div className="field">
      <img
        className="validation-icon"
        src={validationIcon(showValidationIcon, error)}
        data-testid={`${label} validation icon`}
      />
      <input
        className={error && showValidationIcon ? 'validation-error' : ''}
        {...otherProps}
        type="email"
        placeholder={label}
        formNoValidate
        onBlur={(event): void => {
          if (onBlur) {
            onBlur(event);
          }

          if (onValidation) {
            onValidation(error);
          }
        }}
        value={value || ''}
        onChange={onChange}
        required
      />
      <label className="field-label">{label}</label>
      {showValidationIcon && <label className="error-label">{error}</label>}
      <style jsx>{styles}</style>
    </div>
  );
}
